(function () {
  function moneyFromCentsBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getMainProductImage() {
    const selectors = [
      '.product__media img',
      '.product-single__media img',
      '.product-single__photo img',
      '.product__photos img',
      '.product__main-photos img',
      '.product-gallery img',
      '.product__media-item img',
      '[data-product-single-media-wrapper] img',
      '[data-media-id] img',
      '.swiper-slide-active img',
      '.slick-active img'
    ];

    for (const selector of selectors) {
      const img = document.querySelector(selector);
      if (img) return img;
    }

    return null;
  }

  function updateProductMedia(input) {
    if (!input) return;

    const mediaSrc = input.dataset.mediaSrc || '';
    const mediaSrcset = input.dataset.mediaSrcset || '';
    const mediaAlt = input.dataset.mediaAlt || input.dataset.name || '';

    if (!mediaSrc) return;

    const mainImg = getMainProductImage();

    if (!mainImg) {
      console.warn('[BRX Combo] Imagem principal do produto não encontrada.');
      return;
    }

    const picture = mainImg.closest('picture');

    if (picture) {
      picture.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('data-srcset');
      });
    }

    mainImg.style.transition = 'opacity .18s ease';
    mainImg.style.opacity = '0';

    setTimeout(function () {
      mainImg.src = mediaSrc;

      if (mediaSrcset.trim()) {
        mainImg.srcset = mediaSrcset.trim();
      } else {
        mainImg.removeAttribute('srcset');
      }

      mainImg.alt = mediaAlt;
      mainImg.removeAttribute('data-src');
      mainImg.removeAttribute('data-srcset');
      mainImg.removeAttribute('loading');

      mainImg.onload = function () {
        mainImg.style.opacity = '1';
      };

      setTimeout(function () {
        mainImg.style.opacity = '1';
      }, 150);
    }, 120);
  }

  function updateNativeProductPrice(checked) {
    if (!checked) return;

    const price = checked.dataset.price || '';
    const compare = checked.dataset.compare || '';
    const savings = checked.dataset.savings || '';

    const priceEls = document.querySelectorAll('[data-product-price]');
    const compareEls = document.querySelectorAll('[data-compare-price]');
    const compareWraps = document.querySelectorAll('[data-product-price-wrap]');
    const saveEls = document.querySelectorAll('[data-save-price]');
    const compareA11yEls = document.querySelectorAll('[data-compare-price-a11y]');
    const priceA11yEls = document.querySelectorAll('[data-a11y-price]');

    priceEls.forEach(function (el) {
      el.classList.toggle('on-sale', !!compare);

      const visible = el.querySelector('[aria-hidden="true"]');
      const hidden = el.querySelector('.visually-hidden');

      if (visible) visible.textContent = price;
      if (hidden) hidden.textContent = price;

      if (!visible && !hidden) {
        el.textContent = price;
      }
    });

    compareEls.forEach(function (el) {
      const visible = el.querySelector('[aria-hidden="true"]');
      const hidden = el.querySelector('.visually-hidden');

      if (compare) {
        el.style.display = '';
        el.classList.remove('hide');

        if (visible) visible.textContent = compare;
        if (hidden) hidden.textContent = compare;

        if (!visible && !hidden) {
          el.textContent = compare;
        }
      } else {
        el.style.display = 'none';
        el.classList.add('hide');

        if (visible) visible.textContent = '';
        if (hidden) hidden.textContent = '';

        if (!visible && !hidden) {
          el.textContent = '';
        }
      }
    });

    compareWraps.forEach(function (el) {
      if (compare) {
        el.style.display = '';
        el.classList.remove('hide');
      } else {
        el.style.display = 'none';
        el.classList.add('hide');
      }
    });

    saveEls.forEach(function (el) {
      if (savings) {
        el.textContent = 'Economize ' + savings;
        el.style.display = '';
        el.classList.remove('hide');
      } else {
        el.textContent = '';
        el.style.display = 'none';
        el.classList.add('hide');
      }
    });

    compareA11yEls.forEach(function (el) {
      el.textContent = compare ? 'Preço promocional' : '';
    });

    priceA11yEls.forEach(function (el) {
      el.textContent = compare ? 'Preço normal' : 'Preço';
    });
  }

  function init(root) {
    if (!root || root.dataset.brxInit === '1') return;
    root.dataset.brxInit = '1';

    const els = {
      name: root.querySelector('[data-brx-name]'),
      price: root.querySelector('[data-brx-price]'),
      inst: root.querySelector('[data-brx-installments]'),
      compare: root.querySelector('[data-brx-compare]'),
      compareWrap: root.querySelector('[data-brx-compare-wrap]'),
      discountTag: root.querySelector('[data-brx-discount-tag]'),
      save: root.querySelector('[data-brx-save]'),
      btn: root.querySelector('[data-brx-add]'),
      msg: root.querySelector('[data-brx-msg]'),
      cards: Array.from(root.querySelectorAll('[data-brx-card]')),
      ship: root.querySelector('[data-brx-ship]'),
      shipToggle: root.querySelector('[data-brx-ship-toggle]'),
      shipPanel: root.querySelector('[data-brx-ship-panel]')
    };

    function setMsg(text, isSuccess) {
      if (!els.msg) return;

      els.msg.textContent = text || '';
      els.msg.style.color = isSuccess ? '#16a34a' : '#dc2626';
    }

    function getChecked() {
      return root.querySelector('input[name="brx_variant"]:checked');
    }

    function setActiveCard(checked) {
      els.cards.forEach(function (card) {
        card.classList.remove('is-active');
      });

      const active = checked ? checked.closest('[data-brx-card]') : null;
      if (active) active.classList.add('is-active');
    }

    function closeShip() {
      if (!els.ship || !els.shipToggle || !els.shipPanel) return;

      els.ship.classList.add('is-collapsed');
      els.shipToggle.setAttribute('aria-expanded', 'false');
      els.shipPanel.hidden = true;
    }

    function openShip() {
      if (!els.ship || !els.shipToggle || !els.shipPanel) return;

      els.ship.classList.remove('is-collapsed');
      els.shipToggle.setAttribute('aria-expanded', 'true');
      els.shipPanel.hidden = false;
    }

    function toggleShip() {
      if (!els.shipToggle) return;

      const expanded = els.shipToggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        closeShip();
      } else {
        openShip();
      }
    }

    function syncShipVisibility() {
      if (!els.ship) return;
      els.ship.hidden = false;
    }

    function syncNativeVariantInput(checked) {
      if (!checked || !checked.value) return;

      const variantId = checked.value;

      const nativeFields = document.querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
      );

      nativeFields.forEach(function (field) {
        field.value = variantId;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function sync() {
      const checked = getChecked();
      if (!checked) return;

      const name = checked.dataset.name || '-';
      const price = checked.dataset.price || '-';
      const compare = checked.dataset.compare || '';
      const savings = checked.dataset.savings || '';
      const cents = Number(checked.dataset.priceCents || 0);
      const compareCents = Number(checked.dataset.compareCents || 0);

      if (els.name) els.name.textContent = name;
      if (els.price) els.price.textContent = price;

      if (els.compare && els.compareWrap) {
        if (compare) {
          els.compare.textContent = compare;
          els.compareWrap.style.display = 'flex';
        } else {
          els.compare.textContent = '';
          els.compareWrap.style.display = 'none';
        }
      }

      if (els.discountTag) {
        if (compareCents > cents && cents > 0) {
          const pct = Math.round(((compareCents - cents) * 100) / compareCents);
          els.discountTag.textContent = pct + '% OFF';
          els.discountTag.style.display = 'inline-flex';
        } else {
          els.discountTag.style.display = 'none';
        }
      }

      if (els.save) {
        if (savings) {
          els.save.textContent = 'Economize ' + savings;
          els.save.style.display = 'block';
        } else {
          els.save.textContent = '';
          els.save.style.display = 'none';
        }
      }

      if (els.inst) {
        if (cents > 0) {
          const installmentValue = cents / 3;

          els.inst.innerHTML =
            'ou <strong>3x</strong> de <strong>' +
            moneyFromCentsBRL(installmentValue) +
            '</strong> <span>sem juros</span>';

          els.inst.style.display = 'block';
        } else {
          els.inst.textContent = '';
          els.inst.style.display = 'none';
        }
      }

      syncShipVisibility();
      setActiveCard(checked);
      syncNativeVariantInput(checked);
      updateProductMedia(checked);
      updateNativeProductPrice(checked);
    }

    async function refreshCartDrawer() {
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
        try {
          await window.theme.cart.getCart();
        } catch (e) {}
      }
    }

    function openHeaderCartNative() {
      const toggler =
        document.querySelector('[aria-controls="HeaderCart"]:not(#HeaderCart)') ||
        document.querySelector('[data-drawer-open="cart"]') ||
        document.querySelector('[data-drawer-open-cart]') ||
        document.querySelector('.js-drawer-open-cart');

      if (toggler) {
        toggler.click();
        return true;
      }

      return false;
    }

    async function addSelectedVariantToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }

      const checked = getChecked();
      const variantId = checked && checked.value;

      if (!variantId) {
        setMsg('Selecione uma opção disponível.', false);
        return;
      }

      if (els.btn.dataset.brxAdding === '1') return;

      els.btn.dataset.brxAdding = '1';
      els.btn.disabled = true;
      els.btn.setAttribute('aria-busy', 'true');

      setMsg('', true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error(await response.text());
        }

        await response.json();

        await refreshCartDrawer();

        setTimeout(function () {
          openHeaderCartNative();
        }, 180);

        setMsg('Adicionado ao carrinho.', true);
      } catch (error) {
        console.error('[BRX Combo] Erro ao adicionar ao carrinho:', error);
        setMsg('Não foi possível adicionar agora. Tente novamente.', false);
      } finally {
        els.btn.dataset.brxAdding = '0';
        els.btn.disabled = false;
        els.btn.removeAttribute('aria-busy');
      }
    }

    if (els.shipToggle) {
      els.shipToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleShip();
      });
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name="brx_variant"]')) {
        sync();
      }
    });

    if (els.btn) {
      els.btn.setAttribute('type', 'button');

      els.btn.addEventListener(
        'click',
        function (event) {
          addSelectedVariantToCart(event);
        },
        true
      );
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-brx]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();